import React from "react";
import { FaQuoteLeft } from "react-icons/fa";

const ManagerMessageFullWidth = () => {
  const managerImage = "manager.png";

  return (
    <section className="w-full overflow-hidden bg-gradient-to-br from-green-50 via-white to-orange-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="relative">
          <FaQuoteLeft className="absolute -top-6 -left-6 h-12 w-12 text-green-200 md:-top-8 md:-left-8 md:h-16 md:w-16" />

          <div className="flex flex-col items-center gap-10 md:flex-row md:items-start md:gap-16">
            <div className="relative flex-shrink-0">
              <div className="h-56 w-56 overflow-hidden rounded-full border-4 border-white shadow-2xl md:h-80 md:w-80">
                <img
                  src={managerImage}
                  alt="Sandeep Singh, Managing Director"
                  className="h-full w-full object-cover"
                />
              </div>
            </div>
            <div className="flex-1 text-center md:text-left">
              <h2 className="text-3xl font-extrabold text-gray-900 md:text-4xl">
                Manager's Message
              </h2>
              <div className="mt-2">
                <p className="text-xl font-semibold text-green-700 md:text-2xl">
                  Sandeep Singh
                </p>
                <p className="text-sm text-gray-500 md:text-base">Managing Director</p>
              </div>

              <div className="prose prose-base mx-auto mt-6 max-w-none text-gray-600 md:prose-lg md:mx-0 space-y-4">
                <p className="leading-relaxed">
                  The fast changing business environment is changing the mindset of the
                  professionals. Today, nobody thinks only of winning the country's markets;
                  the view is on global markets and to get access to unexplored international
                  business potential. The risks are high but the lure of returns is attracting
                  corporates to new pastures. The future promises are to be even more
                  challenging.
                </p>
                <p className="leading-relaxed">
                  A professional today has to be much more familiar with the changing economic
                  and business scene and should be in a position to use skills to best advantage.
                  Innovative Institute has a crucial role to play in the changing environment.
                  We at Innovative train the upcoming professionals not just in the traditional
                  subjects, but also in the art of adaptability, critical thinking, and global
                  collaboration.
                </p>
                <p className="leading-relaxed">
                  Our commitment is to create a learning ecosystem where every student is
                  empowered with both technical excellence and entrepreneurial mindset.
                  We believe that the youth of today are the architects of tomorrow, and we
                  strive to give them the best possible foundation to build their dreams upon.
                </p>
              </div>

              <div className="mt-8">
                <button className="group inline-flex items-center gap-2 rounded-full bg-gradient-to-r from-green-600 to-orange-500 px-6 py-3 text-base font-semibold text-white shadow-md transition-all hover:shadow-lg hover:scale-105">
                  Read More
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5 transition-transform group-hover:translate-x-1"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth={2}
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M13 7l5 5m0 0l-5 5m5-5H6"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ManagerMessageFullWidth;